import { Directive, input } from '@angular/core';
import type { AbstractControl, FormGroup } from '@angular/forms';

@Directive({})
export abstract class AbstractFormFragmentComponent<
  FORM extends { [key: string]: AbstractControl<any, any> },
> {
  readonly i18nPrefix = input.required<string>();
  readonly loading = input(false);
  readonly parentForm = input.required<FormGroup<FORM>>();
}
